module.exports = __webpack_public_path__ + "fonts/montserrat-v15-latin-300.64c4fc09.ttf";